import { useSyncExternalStore } from "react";

// The left dock's tight column (DeskDock's `w-12`): its width when compact,
// and when Widen Cleo needs its room.
export const DESK_DOCK_TIGHT_PX = 48;

const key = "cleo:desk-dock:wide";
const event = "cleo-dock-width-mode";
let fallback = false;
function read() {
  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    return fallback;
  }
}
function subscribe(listener: () => void) {
  window.addEventListener(event, listener);
  window.addEventListener("storage", listener);
  return () => {
    window.removeEventListener(event, listener);
    window.removeEventListener("storage", listener);
  };
}
export function useDockWide() {
  const wide = useSyncExternalStore(subscribe, read, () => false);
  return [
    wide,
    (next: boolean) => {
      fallback = next;
      try {
        window.localStorage.setItem(key, next ? "1" : "0");
      } catch {
        /* viewer preference */
      }
      window.dispatchEvent(new Event(event));
    },
  ] as const;
}
